const MAC_DOWNLOAD_MANIFEST_URL = 'https://cdn.gab.ai/macos/updates/installers/latest.json';

// Never let a malformed or off-host manifest turn a trusted download button
// into an arbitrary link. Local candidate URLs are accepted only in local QA.
function parseMacDownloadManifest(value, { local = false } = {}) {
  const release = value?.schemaVersion === 1 ? value.release : null;
  if (!release || !/^\d+(?:\.\d+){1,3}$/.test(release.version)
      || !Number.isSafeInteger(release.build) || release.build < 1
      || !/^[a-f0-9]{64}$/.test(release.sha256)
      || !Number.isSafeInteger(release.size) || release.size < 1) return null;
  // Local metadata is written only after staging verifies production endpoints.
  if (local && release.origin !== 'https://gab.ai') return null;
  const name = `Gab-AI-${release.version}-${release.build}`;
  const format = local && release.format === 'zip' ? 'zip' : 'dmg';
  const expected = local
    ? `/macos/local/${name}-${release.sha256.slice(0, 12)}.${format}`
    : `https://cdn.gab.ai/macos/updates/installers/${name}.dmg`;
  return release.url === expected ? release : null;
}
module.exports = { MAC_DOWNLOAD_MANIFEST_URL, parseMacDownloadManifest };
